import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { RootState } from "../../redux/Store";
import * as S from "../../style/StyleComponentSection";
import { get_brand_with_reservation_ID, request_payment } from "../../Axios";
import { commaPrice, get_day_timestamp } from "../../Validation";
import { useDispatch } from "react-redux";
import { reduxOffSpinner, reduxOnSpinner } from "../../redux/CommonSlice";
import { update_nav } from "../../Util";

interface ReservationList {
    construction_reservation_ID                : string;
    construction_reservation_progress          : number;
    construction_reservation_progress_name     : string;
    construction_reservation_division          : number;
    construction_reservation_division_name     : string;
    construction_reservation_name              : string;
    construction_reservation_big_area          : string;
    construction_reservation_small_area        : string;
    construction_reservation_before_big_area   : string;
    construction_reservation_before_small_area : string;
    construction_reservation_reservationTime   : any;
    construction_reservation_time_name         : string;
    construction_reservation_requests          : string;
    construction_reservation_point             : number;
    brand_kor_name                             : string;
    product_name                               : string;
    color_name                                 : string;
    construction_reservation_count             : number;
    construction_reservation_address           : string;
    construction_reservation_before_address    : string;
    construction_reservation_phone_number      : string;
    construction_reservation_pay               : number;
    construction_reservation_high_status_name  : string;
    construction_reservation_result_picture1   : string;
    construction_reservation_result_picture2   : string;
    construction_reservation_result_picture3   : string;
    construction_reservation_result_picture4   : string;
    construction_reservation_pay_status        : number;
};

const Payment: React.FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {state} = useLocation();
    const [paymentInformation, setPaymentInformation] = useState<ReservationList>();
    const customerData = useSelector((state:RootState) => state.customerData);
    const [brandImageUrl, setBrandImageUrl] = useState<string>("");

    useEffect(() => {
        if(!customerData) return;
        if(!state) return;
        state.account_ID = customerData.account_ID;
        state.account_name = customerData.account_name;
        setPaymentInformation(state);
    }, [customerData, state]);

    useEffect(() => {
        if(!paymentInformation?.construction_reservation_ID) return;
        get_brand_with_reservation_ID(paymentInformation?.construction_reservation_ID).then(result => {
            setBrandImageUrl(result.brand_img);
        })
    }, [paymentInformation]);

    // 결제 요청
    const handleRequestPayment = () => {
        if(paymentInformation?.construction_reservation_pay_status === 1) return alert('이미 결제완료 된 예약입니다.');
        if(!customerData.customer_ID) return alert('고객정보에 문제가 있습니다. 다시 로그인해 주세요.');
        if(!paymentInformation?.construction_reservation_ID) return alert('예약번호를 확인할 수 없습니다. 다시 시도해 주세요.');
        if(!paymentInformation?.construction_reservation_pay) {
            return;
        } else {
            if(Number(customerData.customer_point) < paymentInformation?.construction_reservation_pay)  {
                return alert('AP가 부족합니다.');
            }
        };
        if(!window.confirm('결제 하시겠습니까?')) return;
        dispatch(reduxOnSpinner('잠시만 기다려주세요.'));
        request_payment(
            parseInt(paymentInformation?.construction_reservation_ID),
            paymentInformation?.construction_reservation_pay,
            customerData.customer_ID
        ).then(result => {
            dispatch(reduxOffSpinner());
            if(result === 1) {
                let construction_reservation_ID = paymentInformation?.construction_reservation_ID;
                update_nav();
                alert('결제가 완료되었습니다.');
                navigate('/payment_success', {state : construction_reservation_ID});
            } else {
                alert('알 수 없는 오류');
            };
        })
    };

    return (
        <S.SectionContainer>
            <S.SectionWidth $width={1080}>
                <S.SectionTitleBox>
                    <h1>결제 하기</h1>
                    <h3>결제내역 확인과 결제를 진행할 수 있습니다.</h3>
                </S.SectionTitleBox>

                <S.ReservationTableHead>
                    <div className="w-20">시공 제품</div>
                </S.ReservationTableHead>

                <S.PaymentInformationFlexBox>
                    <div className="left-side flex">
                        <div className="logo-box">
                            <img src={brandImageUrl} alt="" />
                        </div>
                        <div className="product-info">
                            <p>{paymentInformation?.brand_kor_name}</p>
                            <p>{paymentInformation?.product_name} / {paymentInformation?.color_name} / {paymentInformation?.construction_reservation_count}개</p>
                        </div>
                    </div>
                    <div className="right-side">
                        <div className="total-point">
                            <span>{commaPrice(Number(paymentInformation?.construction_reservation_pay))} AP</span>
                        </div>
                    </div>
                </S.PaymentInformationFlexBox>

                <S.ReservationTableHead>
                    <div className="w-20">고객 정보</div>
                </S.ReservationTableHead>
                <S.PaymentInformationFlexBox>
                    <div className="client-info">
                        <p>{paymentInformation?.construction_reservation_name} / {paymentInformation?.construction_reservation_phone_number}</p>
                        <p className="mt-[10px]">{paymentInformation?.construction_reservation_address}</p>
                        {/* <p>{paymentInformation?.construction_reservation_before_address}</p> */}
                        <h5 className="mt-[10px]">{paymentInformation?.construction_reservation_division_name} | {get_day_timestamp(paymentInformation?.construction_reservation_reservationTime).year_month_day} {paymentInformation?.construction_reservation_time_name}</h5>
                    </div>
                </S.PaymentInformationFlexBox>

                <S.ReservationTableHead>
                    <div className="w-20">결제 정보</div>
                </S.ReservationTableHead>

                <S.PaymentInformationFlexBox className="ml-[15px]">
                    <div className="payment-left">
                        <p>총 예약 금액</p>
                        <p>사용 가능 포인트</p>
                        {/* <p>사용 포인트</p> */}
                    </div>
                    <div className="payment-right">
                        <p>{commaPrice(Number(paymentInformation?.construction_reservation_pay))} AP</p>
                        <p>{commaPrice(Number(customerData.customer_point))} AP</p>
                        {/* <p>{commaPrice(Number(paymentInformation?.construction_reservation_pay))} AP</p> */}
                        {/* <input type="text" value={inputAP} maxLength={customerMaxLength}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                const {value} = e.target;
                                const onlyNumber = value.replace(/[^0-9]/g, '');
                                setInputAP(onlyNumber);
                            }} 
                        /> <span> AP</span> */}
                    </div>
                </S.PaymentInformationFlexBox>

                <hr />

                <S.PaymentInformationFlexBox className="ml-[15px]">
                    <div className="payment-left">
                        <p>총 결제 금액</p>
                    </div>
                    <div className="payment-right">
                        <p>{commaPrice(Number(paymentInformation?.construction_reservation_pay))} AP</p>
                    </div>
                </S.PaymentInformationFlexBox>

                <S.SectionContent>
                    <div className="section-flex-box w-[100%] justify-center mt-2">
                        <S.EmptyRoundedButton onClick={() => {
                            handleRequestPayment();
                        }} $width={250} $btnSelect>
                            결제하기
                        </S.EmptyRoundedButton>
                    </div>
                </S.SectionContent>

            </S.SectionWidth>
        </S.SectionContainer>
    )
};

export default Payment;